export default __webpack_public_path__ + "login_two.svg";